



















import { Vue, Component } from 'vue-property-decorator';
import { Toast } from 'vant';

Vue.use(Toast);

@Component
export default class Link extends Vue {
  link = 'https://www.cqcb.com/vote/2023project/2023merchants/pages/enroll.php';

  copy() {
    Toast('复制成功');
  }
}
